export interface SoftwareVersions {
  robcoRobotControllerVersion: string;
  robflowFrontendVersion: string;
  robflowBackendVersion: string;
  robcoModuleDatabaseVersion: string;
  robcoRobotCommunicationVersion: string;
  robcoTelemetryVersion: string;
  robflowUtilsVersion: string;
}

export const EMPTY_SOFTWARE_VERSIONS: SoftwareVersions = {
  robcoModuleDatabaseVersion: '-1',
  robcoRobotCommunicationVersion: '-1',
  robcoRobotControllerVersion: '-1',
  robcoTelemetryVersion: '-1',
  robflowBackendVersion: '-1',
  robflowFrontendVersion: '-1',
  robflowUtilsVersion: '-1',
};
